import $ from 'jquery';

export function renderImageSlider() {
	$('#main').find('.picture').each(function () {
		const container = $(this);
		const images = container.children();
		let current = images.first();
		current.css('z-index', 2);

		setInterval(function () {
			const last = current;
			current = current.next();
			current = current.length ? current : images.first();

			last.css('z-index', 3).addClass('picture-hide', 2000);
			setTimeout(function () {
				last.css('z-index', 1).removeClass('picture-hide');
			}, 3000);
			current.css('z-index', 2);
		}, 6000);
	});
}
